export default __webpack_public_path__ + "static/media/notewrote5.619c540c.jpg";